<template>
  <div class="page-right">
    <div class="right-content" style="border-radius:  45% 45% 0 0" @click="Wxkf">
      <div>
        <el-image style="width: 26px;height: 26px" :src="rightMenu.kf1"></el-image>
      </div>
      <div style="color:#515662;">在线客服</div>
    </div>
    <div class="right-content" @mouseenter="showTip = true" @mouseleave="handleMouseLeave">
      <div>
        <el-image style="width: 28px" :src="rightMenu.ewm1"></el-image>
      </div>
      <div style="color:#515662;">APP下载</div>
    </div>
    <div class="right-content" @mouseenter="showTipTwo = true" @mouseleave="handleMouseLeaveTwo">
      <div>
        <el-image style="width: 28px" :src="rightMenu.yj1"></el-image>
      </div>
      <div style="color: #515662;">联系电话</div>

    </div>
    <div class="right-content" style="border-radius: 0 0 45% 45%" @click="toTop">
      <div>
        <el-image style="width: 28px" :src="rightMenu.fhdb1"></el-image>
      </div>
    </div>
    <div v-show="showTip" class="tooltip" @mouseenter="showTip = true" @mouseleave="handleMouseLeave">
      <div style="padding: 20px">
        <div style="display: flex; align-items: center;">
          <div style="flex-shrink: 0;">
            <el-image
                :src="rightMenu.apkCode"                style="width: 200px; height: 200px; cursor: pointer;"
                @click="showLargeQrCode = true"
                :preview-src-list="[rightMenu.apkCode]"
            ></el-image>
          </div>
          <div style="margin-left: 25px;">
            <p style="font-size: 18px; font-weight: bold; margin-bottom: 12px;">智采管家APP</p>
            <p style="font-size: 15px;"><span style="color: #e6a23c">安卓手机</span>扫码下载手机端APP</p>
          </div>
        </div>
      </div>
    </div>
    <div v-show="showTipTwo" class="tooltip1" @mouseenter="showTipTwo = true" @mouseleave="handleMouseLeaveTwo">
      <div style="padding: 16px">
        <div style="width: 288px">
          <div>
            <p>联系电话客服</p>
            <p style="margin-top: 10px">400-666-0654（工作时间：8:30-18:00）</p>
          </div>
        </div>
      </div>
    </div>
    <!--    <el-dialog center   :visible.sync="opinionDiong" width="800px" append-to-body>-->
    <!--      <div v-if="!type">-->
    <!--        <el-form style="width: 100%;" v-model="opinionfrom"  label-width="120px">-->
    <!--          <el-form-item label="意见反馈:" prop="phone">-->
    <!--            <el-input type="textarea" :rows="2" :autosize="{ minRows: 2, maxRows: 4}" v-model="opinionfrom.suggestions" placeholder="请输入您的意见或建议"></el-input>-->
    <!--          </el-form-item>-->
    <!--          <el-form-item label="上传图片" prop="name">-->
    <!--            <file-upload  style="margin-left: 20px" ref="upload"  :file-type="['pdf','png', 'jpg', 'jpeg']" :file-size="10"  @getUploadResult="getUploadResult"></file-upload>-->
    <!--            <div v-if="typeof opinionfrom.fileGuId !== 'string'" v-for="(item,index) in opinionfrom.fileGuId ">-->
    <!--              <attachments :fileId="item" style="display: inline-block"/>-->
    <!--              <el-button  size="mini"  style="margin-left: 10px" @click="opinionfrom.fileGuId.splice(index,1)">删除</el-button>-->
    <!--            </div>-->
    <!--          </el-form-item>-->
    <!--        </el-form>-->
    <!--        <div style="text-align: center;">-->
    <!--                        <el-button @click="yjSubmit" style="background: #0492FF;border-radius: 2px ;padding: 10px 38px ;font-size: 18px;color: #FFFFFF;">立即提交</el-button>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--      <div v-else style="display: flex;justify-content: center;align-items: center;flex-direction: column">-->
    <!--        <el-image style="width: 80px;height: 80px;margin-bottom: 40px" :src="require('@/assets/images/rightMenuImages/cg.png')"></el-image>-->
    <!--        <div style="color: #333333;font-size: 20px;margin-bottom: 16px">提交成功</div>-->
    <!--        <div style="font-size: 14px;color: #666666;margin-bottom: 114px">感谢您的建言，它会成为我们优化产品与服务的宝贵指引</div>-->
    <!--        <div>-->
    <!--          <el-button style="padding: 10px 56px;font-size: 18px;color: #FFFFFF;background: #0492FF;border-radius: 2px;" @click="opinionDiong = false">关闭</el-button>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </el-dialog>-->
  </div>
</template>
<script>
import { rightMenu } from "@/utils/images";
import FileUpload from "@/components/FileUpload.vue";
import Attachments from "@/components/Attachments.vue";
import {suggestionsApi} from "@/api/api";
export default {
  components:{
    Attachments,
    FileUpload,
  },
  data() {
    return {
      rightMenu:rightMenu,
      showTip:false,
      showTipTwo:false,
      showTipType:1,
      opinionDiong:false,
      opinionfrom:{suggestions:'' ,fileGuId:[]},
      type:false,
      showLargeQrCode:false
    };
  },
  methods: {
    handleMouseLeave() {
      setTimeout(() => {
        if (!this.$el.querySelector('.tooltip:hover')) {
          this.showTip = false
        }
      }, 100)
    },
    handleMouseLeaveTwo() {
      setTimeout(() => {
        if (!this.$el.querySelector('.tooltip1:hover')) {
          this.showTipTwo = false
        }
      }, 100)
    },
    setMouseleave(val){
      if (val === 3){
        this.showTipTwo = true
      }else {
        this.showTip = true
      }
      this.showTipType = val
    },
    toTop(){
      document.getElementsByClassName('app_content')[0].scrollTop = 0
    },
    opinion(){
      this.type = false
      this.opinionDiong = true
      this.opinionfrom = {suggestions:'', fileGuId:[]}
    },
    getUploadResult(res) {
      if(res.length>0){
        this.opinionfrom.fileGuId.push(res[0].fileGuid)
      }
      this.$refs.upload.file()
    },
    yjSubmit(){
      if(this.opinionfrom.suggestions.length<=0) return this.$message.error('请输入您的意见或建议')
      let form = {...this.opinionfrom}
      let fileGuId = form.fileGuId
      if(fileGuId && fileGuId.length > 0){
        form.fileGuId = fileGuId.join(',')
      }
      suggestionsApi(form).then(res =>{
        if(res && res.code === 200){
          this.type = true
        }else{
          this.$message.error(res.message)
        }
      })
    },
    Wxkf(){
      window.open("https://work.weixin.qq.com/kfid/kfc4d0342e52b2c8adb")
    }
  }
};
</script>
<style lang="less" scoped>
.page-right{
  width: 70px;
  position: fixed;
  right: 20px;
  top: 500px;
  align-items: flex-end;
  z-index: 99;
}
.right-content{
  width: 100%;
  height: 80px;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #FFFFFF;
  cursor: pointer;
}
.tooltip {
  position: absolute;
  top: 90px;
  right: 75px;
  border: 1px solid #ccc;
  background: url("../assets/images/rightMenuImages/bj.png") no-repeat;
  background-size: cover;
  background-position: 100% 100% ;
  box-shadow: 0 1px 5px gray;
  min-width: 440px;
  min-height: 240px;
  font-size: 14px;
}
.tooltip1 {
  position: absolute;
  top: 185px;
  border: 1px solid #ccc;
  transform: translateX(calc(-100% - 5px));
  background: url("../assets/images/rightMenuImages/bj.png") no-repeat;
  background-size: cover;
  background-position: 100% 100% ;
  box-shadow: 0 1px 5px gray;
  width: 288px;
  height: 88px;
  font-size: 14px;
}
</style>
